import React from 'react';
import styled from 'styled-components';
import Marker from '../ProductJourney/Map/Marker/Marker';
import theme from 'utils/theme';
import { useTranslation } from 'react-i18next';
import Icon from '../Icon/Icon';
import FlexBox from '../Container/FlexBox';
const Header = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const Title = styled.div `
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const StyledMarker = styled(Marker) `
  transform: scale(0.7);
`;
const RAW_MATERIAL_COLOR_STATE = {
    default: {
        color: theme.palette.grey.A800,
        backgroundColor: '#fff',
    },
    selected: {
        color: theme.palette.grey.A800,
        backgroundColor: theme.palette.primary.main,
    },
    highlight: {
        color: theme.palette.grey.A800,
        backgroundColor: theme.palette.primary.light,
    },
};
const RawMaterial = styled.div `
  display: inline-flex;
  padding: 4px 8px;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadiusButton};
  background: ${({ colorState }) => RAW_MATERIAL_COLOR_STATE[colorState].backgroundColor};
  color: ${({ theme }) => theme.palette.grey.A800};
  font-weight: 700;
  font-size: 14px;
  margin-left: 8px;
`;
const BatchHeader = ({ image, rawMaterialTitle, noRawMaterialSelected, hasOtherIngredients, hideLocationPin, }) => {
    const { t } = useTranslation();
    return (React.createElement(Header, null,
        !noRawMaterialSelected && !hideLocationPin && (React.createElement(StyledMarker, { image: image, active: true })),
        React.createElement(Title, null, t('my-batch')),
        React.createElement(RawMaterial, { colorState: noRawMaterialSelected ? 'default' : 'selected' }, rawMaterialTitle ? rawMaterialTitle : t('select-ingredient')),
        hasOtherIngredients && (React.createElement(FlexBox, { ml: 1 },
            React.createElement(Icon, { name: "plus" }),
            React.createElement(RawMaterial, { colorState: "highlight" }, t('mixed-ingredients'))))));
};
export default BatchHeader;
